<template>
  <div class="employee" v-loading="processing" :class="{'disable' : is_after_today}">
    <div class="employee-info">
      <h4>{{ employee.name }}</h4>
      <p>{{ employee.card }}</p>
      <span v-if="employee.id" class="badge warning">
          Confirmado
      </span>
    </div>
    <div class="checkin-status">
      <select :class="styleStatus"
              :disabled="!canAdd()"
              v-model="employee.checkin_status_id"
              @change="onChangeStatus()"
              name="checkin_status_id" >
        <option :value="status.id" v-for="status in checkin_statuses" :key="status.id">{{ status.name}}</option>
      </select>
    </div>
    <div class="employee-info" v-if="employee.checkin_status_id === 6">
      <el-switch
        :disabled="!canAdd()"
        v-model="employee.payed"
        active-color="#13ce66"
        inactive-color="#ff4949"
        active-text="Pagada"
        inactive-text="No Pagada">
      </el-switch>
    </div>
    <table v-if="employee.checkin_status_id === 1 || employee.checkin_status_id === 3">
      <tr>
        <td>Horas Dobles</td>
        <td>
          <input type="number"
                 class="hours"
                 min="0"
                 max="16"
                 :disabled="!canAdd()"
                 v-model="employee.double_hours"
                 placeholder="Horas Dobles">
        </td>
      </tr>
      <tr>
        <td>Horas Extras</td>
        <td>
          <input type="number"
                 class="hours"
                 min="0"
                 max="16"
                 :disabled="!canAdd()"
                 v-model="employee.extra_hours"
                 placeholder="Horas Extras">
        </td>
      </tr>
      <tr>
        <td>Horas Trabajadas</td>
        <td>
          <input type="number"
                 class="hours"
                 min="0"
                 max="8"
                 :disabled="employee.checkin_status_id == 1 || !canAdd()"
                 v-model="employee.worked_hours"
                 @change="onChangeWorkedHours()"
                 placeholder="Horas Trabajadas">
        </td>
      </tr>
    </table>
    <el-button-group v-if="canDelete() || canAdd()">
      <el-button class="btn-save"
                 type="default"
                 :disabled="employee.status === 'Aprobado' || employee.status === 'Pendiente'"
                 v-if="canDelete() && employee.id"
                 @click="remove()" plain>
        Eliminar
      </el-button>
      <el-button class="btn-save"
                 type="success"
                 :disabled="employee.status === 'Aprobado' || employee.status === 'Pendiente'"
                 v-if="canAdd()"
                 @click="save()" plain>
        Guardar
      </el-button>
    </el-button-group>
  </div>
</template>

<script>
  import {baseApi} from '../../configs/urls'
  import {parseError} from '../../packages/Helpers'
  import Permissions from '../../components/abstract/Permissions'

  export default {
    name: 'employee',
    extends: Permissions,
    props: ['employee', 'day', 'cost_center_id', 'is_after_today'],
    data () {
      return {
        // employee: {},
        checkin_statuses: [
          { id: 1, name: 'Presente' },
          { id: 2, name: 'Ausente' },
          { id: 3, name: 'Tarde' },
          { id: 4, name: 'Maternidad' },
          { id: 5, name: 'Incapacidad INS' },
          { id: 6, name: 'Incapacidad CCSS' }
        ],
        processing: false,
        basePermission: 'checkin'
      }
    },
    computed: {
      styleStatus () {
        let css = ''
        const status = Number(this.employee.checkin_status_id)

        if (status === 1) {
          css += 'text-success'
        } else if (status === 2) {
          css += 'text-danger'
        } else if (status === 3) {
          css += 'text-warning'
        } else if (status > 3) {
          css += 'text-info'
        }
        return css
      }
    },
    methods: {
      onChangeStatus () {
        if (Number(this.employee.checkin_status_id) === 2 || Number(this.employee.checkin_status_id) > 3) {
          this.employee.extra_hours = 0
          this.employee.double_hours = 0
          this.employee.worked_hours = 0
          this.employee.not_worked_hours = 0
        }

        if (Number(this.employee.checkin_status_id) !== 6) {
          this.employee.payed = false
        }
        if (Number(this.employee.checkin_status_id) === 1) {
          this.employee.not_worked_hours = 0
          this.employee.worked_hours = 8
        }
      },
      getDay () {
        return this.day.format('YYYY-MM-DD')
      },
      onChangeWorkedHours () {
        if (this.employee.worked_hours >= 0 && this.employee.worked_hours < 8) {
          this.employee.not_worked_hours = 8 - this.employee.worked_hours
        } else {
          this.employee.not_worked_hours = 0
        }
      },
      save () {
        if (
          !this.validNumberInput(this.employee.extra_hours, 0, 16) ||
          !this.validNumberInput(this.employee.double_hours, 0, 16) ||
          !this.validNumberInput(this.employee.worked_hours, 0, 8)
        ) {
          this.$message.error(
            this.employee.name + ': Verifica que las Horas Dobles, Horas Extras u Horas Trabajadas sean validas.'
          )
          return
        }

        this.employee.cost_center_id = this.cost_center_id
        this.employee.date = this.getDay()
        this.onChangeStatus()

        this.processing = true
        this.$http.post(baseApi + '/checkins', this.employee).then(
          (response) => {
            this.processing = false
            this.employee.id = response.data.id
            this.$emit('employeeSaved', this.employee)
            this.$message.success(
              'Se guardo correctamente ' + this.employee.name + ' en el dia ' + this.getDay()
            )
          },
          (res) => {
            this.processing = false
            this.$message.error(parseError(res)[0])
          }
        )
      },
      remove () {
        this.processing = true
        this.$http.delete(baseApi + '/checkins/' + this.employee.id).then(
          () => {
            this.processing = false
            this.$emit('employeeRemoved', this.employee.id)
          },
          (res) => {
            this.processing = false
            this.$message.error(parseError(res)[0])
          }
        )
      },
      validNumberInput (value, min, max) {
        return value >= min && value <= max
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/checkins/Employee.vue